
<template>
	<div class="card">
		<div class="card-header">
			<h5 class="header-case">Social Feed</h5>
		</div>
		<div class="card-body">
			<social-stats :stats="stats"></social-stats>
			<div class="d-flex justify-content-center align-items-center">
				<h5 class="mb-0">Show me pictures of</h5>
				<div class="dropdown stylish">

		            <div class="dropdown-select" data-toggle="dropdown">
		                <span v-if="label != ''" class="active">{{ labelTitle }}</span>
		                <span v-else>Everything!</span>
		            </div>

		            <div class="dropdown-menu dropdown-scroll">
		            	<a
		                   class="dropdown-item"
		                   :class="{active: label == ''}"
		                   href="#" @click.prevent="selectTopic('')">Everything</a>
		                <a v-for="aTopic in topics"
		                   class="dropdown-item"
		                   :class="{active: label == aTopic.label}"
		                   href="#" @click.prevent="selectTopic(aTopic.label, aTopic.title)">{{ aTopic.title }}</a>
		            </div>
	        	</div>
			</div>
			<instagram-feed-adv :label="label" :user="user" :teams="teams"></instagram-feed-adv>
		</div>
	</div>
</template>

<script type="text/javascript">
	import InstagramMixin from "../instagram/InstagramMixin"
	import InstagramService from "../../services/instagram-service"
    import Vue from 'vue'

	export default {
		mixins: [InstagramMixin],
		props: ['teams', 'user'],
		data() {
			return {
				topics: null,
				label: '',
				labelTitle: '',
				stats: {
					totalPosts: 0,
					totalLikes: 0,
					totalComments: 0,
					totalCreators: 0
				}
			}
		},
		mounted() {
			this.loadAll(true)
		},
		methods: {
			selectTopic(topic, title) {
				this.label = topic
				this.labelTitle = title
				this.$eventHub.$emit('updateSocialFeed', {label: this.label, page: 1})
				this.updateStats()
			},
			async updateStats() {
				const params = {
					filters: {},
					from: '2000-01-01',
					to: moment().format('YYYY-MM-DD')
				}

				if(!this.selectedHashtags.length) {
	                params.filters.hashtags = this.jwtHashtags
	            } else {
	                params.filters.hashtags = this.selectedHashtags
	            }

				params.filters.locations = this.selectedLocations
	            params.filters.profileIDs = this.selectedProfiles
	            params.filters.profileIDs = this.selectedProfiles
	            params.filters.label = this.label

				const stats = await InstagramService.v2.stats.get(Object.assign({}, _.pick(params, 'from', 'to', 'filters')))
                Vue.set(this, 'stats', stats);
			},
			async loadAll(initial = false) {
				const params = {
	                filters: {
	                },
	                from: '2000-01-01',
	                to: moment().format('YYYY-MM-DD'),
	                sortBy: 'totalLikes',
	                sortOrder: 'desc'
	            }

	            if(!this.selectedHashtags.length) {
	                params.hashtags = this.jwtHashtags
	            } else {
	                params.hashtags = this.selectedHashtags
	            }

	            params.filters.label = this.label

	            if (initial) {
					const stats = await InstagramService.v2.stats.get(Object.assign({}, _.pick(params, 'from', 'to', 'filters')))
                    Vue.set(this, 'stats', stats);

	            	const topics = await InstagramService.v2.topics.index(Object.assign({}, _.pick(params, 'from', 'to', 'filters'), {page: 1, limit: 10}))
	            	this.topics = topics.data
	            }

            	this.updateStats()
			}
		}
	}
</script>
